<template>
  <div>
    <VButton data-cy="add-default-community-button" type="secondary" :on-click="openModal">
      <slot></slot>
    </VButton>
    <modal @close="closeModal()"
           v-if="showModal"
           height="450px"
           overflow-y="auto"
    >
      <div slot="header">
        {{ $t('community.communities.searchForCommunity') }}
      </div>
      <div slot="body">
        <div class="content">
          <SearchInput type="community" />
          <div class="result-container">
            <div v-if="hasSearched && (!communities || communities.length === 0)">
              {{ $t('search.search.noResult') }}
            </div>
            <SearchResultCommunityItem
              v-for="community in communities"
              :key="community.id"
              :community="community"
              :on-click="() => onSelectCommunity(community)"
            />
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/shared/Modal'
import VButton from '@/components/shared/VButton'
import SearchInput from '../search/SearchInput'
import { mapState } from 'vuex'
import SearchResultCommunityItem from '../search/SearchResultCommunityItem'

export default {
  name: 'ConfigSelectCommunityModal',
  components: { Modal, VButton, SearchInput, SearchResultCommunityItem },
  data() {
    return {
      showModal: false
    }
  },
  props: {
    onSelect: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapState({
      communities: state => state.search.searchResult.community,
      hasSearched: state => state.search.hasSearched
    })
  },
  methods: {
    onSelectCommunity(community) {
      console.log('coucou')
      this.onSelect(community)
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
      this.$store.dispatch('resetSearch')
    },
    openModal() {
      this.showModal = true
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  padding: 10px 24px 0 24px;

  .result-container {
    height: 200px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
}

</style>
